import React from 'react';

export enum TenantName {
	YJSG_INDORE = 'YJSG-Indore',
	YJSG_UJJAIN = 'YJSG-Ujjain',
	YJSG_BHOPAL = 'YJSG-Bhopal',
	DEFAULT = 'default',
}

type TenantContextProps = {
	tenant?: TenantName;
	setTenant: React.Dispatch<React.SetStateAction<TenantName>>;
};

const tenant: TenantContextProps = {
	tenant: TenantName.DEFAULT,
	setTenant: () => undefined,
};

export const TenantContext = React.createContext(tenant);
